import { StyledParagraph } from './paragraph.style.js';

export const Paragraph = ({ children, ...rest }) => {
  return <StyledParagraph {...rest}>{children}</StyledParagraph>;
};

export default Paragraph;
